// extracted by mini-css-extract-plugin
export default {"section_label":"SectionLabel_section_label__ZpXcN"};